import type { AppProps, NextWebVitalsMetric } from 'next/app'
import Router from 'next/router'
import { useEffect } from 'react'
import { clientConfig } from '../client'
import { defineNativeToWeb } from '../client/nativeToWeb'
import { useAppWarmupNavigation, useNativeAppRouter } from '../contexts'
import { IPageProps } from '../types'
import { config } from '../lib'
import { captureImaNavReferrer } from '../utils/imaReferrer'

function MyApp({ Component, pageProps }: AppProps) {
  const allProps = pageProps as Partial<IPageProps> | undefined

  const page = allProps?.page
  const adTargetEnv = allProps?.adTargetEnv || config.adTargetEnv

  useNativeAppRouter(page, adTargetEnv || '')
  useAppWarmupNavigation()

  useEffect(() => {
    const onRouteChangeStart = () => {
      captureImaNavReferrer(window.location.href)
    }
    Router.events.on('routeChangeStart', onRouteChangeStart)
    return () => {
      Router.events.off('routeChangeStart', onRouteChangeStart)
    }
  }, [])

  defineNativeToWeb()
  return <Component {...pageProps} />
}

export function reportWebVitals(metric: NextWebVitalsMetric) {
  if (clientConfig.disableMetrics === '1') {
    return
  }

  console.log(metric)
}

export default MyApp
